var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZenBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 103 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_489)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_98_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3592 134.291C77.8742 134.291 99.3689 131.487 99.3689 128.029C99.3689 124.571 77.8742 121.767 51.3592 121.767C24.8442 121.767 3.34949 124.571 3.34949 128.029C3.34949 131.487 24.8442 134.291 51.3592 134.291Z",
    fill: "#B96A39"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.6945 81.8186C76.1068 82.3697 77.4973 82.9397 78.839 83.6262L79.4142 83.9299C84.1064 86.4824 88.2761 90.4465 90.5519 95.3127L90.7667 95.7864C92.5886 99.9544 92.9035 104.579 91.3419 108.851L91.1847 109.263C90.1679 111.829 88.5477 114.154 86.6378 116.156L86.2521 116.551C77.5522 125.297 64.5658 127.917 52.5236 127.882L51.3615 127.871C39.1225 127.664 25.1281 125.365 16.9884 116.27L16.9796 116.261L16.5812 115.867C14.7495 113.999 13.2964 111.694 12.3263 109.263L12.1261 108.74C10.5641 104.495 10.6666 99.1802 12.4601 94.9954L12.6388 94.594C15.7695 87.8315 22.1438 83.4848 28.9786 80.9709L74.6945 81.8186Z",
    fill: "url(#paint0_linear_98_489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9884 116.27C25.1281 125.365 39.1225 127.664 51.3615 127.871L52.5236 127.882C64.5658 127.917 77.5522 125.297 86.2521 116.551L86.6378 116.156C88.5477 114.154 90.1679 111.829 91.1847 109.263L91.3419 108.851C92.9035 104.579 92.5886 99.9544 90.7667 95.7864L90.5519 95.3127C88.2761 90.4465 84.1064 86.4824 79.4142 83.9299L78.839 83.6262C77.4973 82.9397 76.1068 82.3697 74.6945 81.8186L28.9786 80.9709C22.1438 83.4848 15.7695 87.8315 12.6388 94.594L12.4601 94.9954C10.6666 99.1802 10.5641 104.495 12.1261 108.74L12.3263 109.263C13.2964 111.694 14.7495 113.999 16.5812 115.867L16.9796 116.261L16.9884 116.27ZM16.9884 116.27L16.8712 116.374",
    stroke: "#F36111",
    strokeWidth: 0.316176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3909 42.0182C51.4182 41.9118 54.6005 42.5404 57.2932 43.2027C58.636 43.533 59.8515 43.8701 60.7307 44.1246C61.17 44.2518 61.5253 44.3585 61.7708 44.4332C61.8935 44.4706 61.9894 44.5001 62.054 44.5201C62.086 44.5301 62.1108 44.5374 62.1272 44.5426C62.1353 44.5451 62.1417 44.5472 62.1458 44.5484L62.1497 44.5504H62.1516L62.1633 44.5543L62.175 44.5563C69.34 45.6804 76.446 49.2847 80.9319 55.065L81.3577 55.6314C83.9541 59.1947 85.3889 63.6463 84.8225 68.0377L84.761 68.4625C84.0233 73.1095 81.0518 77.0023 77.3391 79.7848L76.9778 80.0504C76.2339 80.5869 75.4523 81.0622 74.6526 81.5211C73.4221 82.1674 72.1964 82.7676 70.9133 83.273L70.3596 83.484C59.5693 87.445 45.7226 86.6393 34.76 83.0201L33.7083 82.6607C32.5022 82.2354 31.3416 81.733 30.1809 81.2047L29.0188 80.6695C28.7748 80.5473 28.5318 80.4176 28.2913 80.2828L27.5745 79.8639C23.6376 77.4702 20.1075 73.7455 18.8567 69.2447L18.7434 68.8072C17.6813 64.4209 18.6681 59.8031 20.926 55.9439L21.1487 55.5729C24.5306 50.0657 29.9061 46.3596 36.0999 44.7223L36.7014 44.5709L36.7063 44.5689H36.7083L36.7122 44.568C36.7162 44.5669 36.7228 44.5653 36.7307 44.5631C36.7467 44.5587 36.7707 44.5521 36.802 44.5436C36.8646 44.5265 36.9572 44.5014 37.0764 44.4693C37.315 44.4052 37.6609 44.3127 38.0891 44.2018C38.9457 43.9799 40.1323 43.6817 41.4524 43.3766C43.9314 42.8036 46.8698 42.2097 48.9797 42.0455L49.3909 42.0182Z",
    fill: "url(#paint1_linear_98_489)",
    stroke: "#FFAB0C",
    strokeWidth: 0.316176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9734 17.6588C46.9766 15.4865 53.8443 15.4213 59.7166 17.9947L60.282 18.2516C64.3485 20.1736 67.9374 23.5787 69.5769 27.8053L69.7292 28.2174C70.7367 31.0682 70.7069 34.2318 69.4675 36.9908L69.3445 37.2574C67.809 40.4411 65.1884 42.5506 62.1394 44.2516C61.8704 44.3148 61.5989 44.4076 61.3347 44.5045L60.5369 44.7965C59.8248 45.0356 59.1111 45.25 58.3865 45.4283L57.657 45.5943C51.3402 46.9092 42.7384 46.6714 36.7263 44.2711C33.4482 42.7705 30.5115 40.5288 29.1267 37.149L28.9978 36.818C27.9563 34.015 28.1603 30.8757 29.2898 28.1256L29.5281 27.5807C31.657 22.9963 35.8441 19.6313 40.5193 17.8277L40.9734 17.6588Z",
    fill: "url(#paint2_linear_98_489)",
    stroke: "#FFBA18",
    strokeWidth: 0.316176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9077 9.61381C87.0837 9.608 87.2507 9.60577 87.4028 9.63236L87.5552 9.67143C87.8256 9.76734 88.0688 9.97383 88.2114 10.2261L88.2661 10.3364C88.3988 10.6478 88.335 11.0444 88.2134 11.4087L88.1587 11.562C87.9126 12.2023 87.2409 13.1398 86.3101 14.2163C85.3838 15.2874 84.2149 16.4807 82.9927 17.6294C81.7705 18.778 80.4963 19.8807 79.3608 20.771C78.2307 21.6571 77.2473 22.3233 76.5913 22.6216C76.2429 22.6879 75.9217 22.6981 75.6216 22.5786L75.4917 22.5181C75.3929 22.4648 75.3216 22.3959 75.2769 22.3071L75.2407 22.2124C75.1798 21.9861 75.2173 21.707 75.3101 21.4126C75.3559 21.2671 75.4136 21.1228 75.4751 20.9858L75.6626 20.6021C76.5118 18.9726 78.442 16.5 80.6128 14.2905C81.6968 13.1873 82.8371 12.1532 83.9282 11.3257C85.0132 10.5029 86.0399 9.89154 86.9077 9.61381Z",
    fill: "url(#paint3_linear_98_489)",
    stroke: "#F36111",
    strokeWidth: 0.316176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5977 0.289465C72.9446 0.29471 73.2536 0.390166 73.499 0.606848L73.6006 0.707434C73.8945 1.03394 73.9957 1.50359 74.001 1.97208L73.9971 2.17227C73.931 3.69414 73.0774 6.32008 71.9443 8.83829C71.3795 10.0937 70.7487 11.3161 70.1172 12.352C69.4886 13.3829 68.8648 14.2195 68.3125 14.724C68.2637 14.7515 68.2166 14.778 68.1699 14.8021L68.0137 14.8744C67.8121 14.9533 67.6193 14.9842 67.4463 14.9311L67.374 14.9027C67.2549 14.8472 67.1555 14.731 67.0811 14.5922L67.0146 14.4477C66.9327 14.2336 66.8906 13.9392 66.8877 13.5756C66.8848 13.2141 66.9208 12.7935 66.9873 12.3314C67.1204 11.4067 67.3745 10.3273 67.6787 9.24454C68.2111 7.34982 68.8924 5.4561 69.3271 4.37735L69.4971 3.9672C69.8087 3.24254 70.1561 2.46715 70.6143 1.79727C71.0668 1.13568 71.6207 0.587631 72.3408 0.292394C72.4264 0.289577 72.512 0.288366 72.5977 0.289465Z",
    fill: "url(#paint4_linear_98_489)",
    stroke: "#F36111",
    strokeWidth: 0.316176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3102 26.5142C90.773 26.4795 91.3729 26.4471 91.9459 26.5034C92.4521 26.5532 92.9155 26.6704 93.2457 26.895L93.3785 26.9976C93.6071 27.1993 93.7651 27.471 93.8112 27.7642L93.8239 27.8911C93.8425 28.3012 93.6787 28.7037 93.4137 29.0298L93.2936 29.1646C92.8789 29.5944 92.1803 29.9479 91.3033 30.2329C90.4307 30.5164 89.4002 30.7267 88.3395 30.8823C86.7483 31.1158 85.0991 31.2254 83.8317 31.2769L82.7076 31.311C82.1909 31.3167 81.5462 31.3681 80.9059 31.3403C80.3452 31.316 79.8319 31.2309 79.4645 31.021L79.316 30.9233C79.141 30.7898 78.9987 30.5805 78.9547 30.3726L78.942 30.2837V30.2827C78.9302 30.1115 78.9798 29.9659 79.0768 29.8208L79.1891 29.6743C79.552 29.2533 80.2646 28.8517 81.1959 28.4839C82.1207 28.1186 83.2373 27.7958 84.3834 27.522C86.3895 27.0428 88.4737 26.7161 89.7535 26.5718L90.2506 26.521H90.2555L90.3102 26.5142Z",
    fill: "url(#paint5_linear_98_489)",
    stroke: "#F36111",
    strokeWidth: 0.316176
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_98_489",
    x: 0.00968742,
    y: 118.427,
    width: 102.699,
    height: 19.2038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6699,
    result: "effect1_foregroundBlur_98_489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_489",
    x1: 51.6871,
    y1: 80.8127,
    x2: 51.6871,
    y2: 128.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_489",
    x1: 51.6303,
    y1: 44.3999,
    x2: 51.6303,
    y2: 86.2724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB31C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_489",
    x1: 49.3819,
    y1: 15.8873,
    x2: 49.3819,
    y2: 46.5464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_489",
    x1: 81.7756,
    y1: 9.4517,
    x2: 81.7756,
    y2: 22.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_98_489",
    x1: 70.4442,
    y1: 0.131262,
    x2: 70.4442,
    y2: 15.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_98_489",
    x1: 86.3825,
    y1: 26.3149,
    x2: 86.3825,
    y2: 31.5067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56821"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 138,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenBlob);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;